import { AxiosError } from 'axios';
import { axiosClient } from '@nx-frontend/shared/api';
import { webnotesThemeColors, webnotesThemeStyle } from '@nx-frontend/shared/themes/webnotes';
import { PaywallPopupReason, PopupType, TranslatesFnType } from '@nx-frontend/shared/types';
import { Workspace } from '@nx-frontend/shared/types';
import { OpenModalFn } from '@nx-frontend/shared/types';
import { GetOpenPayWallPopupProps } from '@nx-frontend/shared/types';

export type CreateWorkspaceActionFn = (
  orgId: string,
  openModal: OpenModalFn,
  closeModal: () => void,
  getOpenPaywallPopup: (props: GetOpenPayWallPopupProps) => void,
  noRedirect?: boolean,
  onSuccess?: (props: Workspace) => void
) => void;

/**
 * Shows create space modal and redirects to the created space
 * @param t expects global scope translations
 * @param openModal
 * @param workspaceId
 * @param parentId
 * @param router
 */
/**
 * @deprecated Use `useOpenCreateWorkspaceDialog`
 */
export const createWorkspace =
  (t: TranslatesFnType): CreateWorkspaceActionFn =>
  (
    orgId: string,
    openModal: OpenModalFn,
    closeModal: () => void,
    getOpenPaywallPopup: (props: GetOpenPayWallPopupProps) => void,
    noRedirect?: boolean,
    onSuccess?: (props: Workspace) => void
  ) => {
    const modalTitle = t('webnotes.webnotes-add_new_workspace');
    const folderDefaultTitle = t('webnotes.webnotes-new_workspace');

    openModal({
      title: modalTitle,
      content: PopupType.RENAME,
      showCloseButton: true,
      closeButtonSize: 18,
      payload: {
        type: 'workspace',
        value: folderDefaultTitle,
        payloadType: PopupType.RENAME,
        themeColors: webnotesThemeColors,
        themeStyle: webnotesThemeStyle,
        onApply: async (value: string) => {
          try {
            const workspace = (
              await axiosClient.post<Workspace>(`/v2/api/workspaces/create`, {
                orgId: orgId,
                title: value,
                skipLimits: false,
              })
            ).data;

            if (!noRedirect) {
              window.location.href = `/space/${workspace.globalId}/all`;
            }
            onSuccess?.(workspace);
          } catch (err) {
            const error = err as AxiosError;
            closeModal();
            if (
              error.response &&
              error.response.data &&
              'object' === typeof error.response.data &&
              'name' in error.response.data &&
              'LimitError' === error.response.data.name
            ) {
              getOpenPaywallPopup({
                openModal,
                payload: {
                  payloadType: PopupType.PAYWALL,
                  mode: 'upgrade',
                  title: t('features.paywall.title_increase_workspaces_by_upgrading'),
                  reason: PaywallPopupReason.WORKSPACES_LIMIT,
                  orgId: orgId,
                },
              });
            }
          }
        },
      },
    });
  };
